import { HandlingMode } from '~/shared';
import { createSlice } from '../wrappers';

const initialState = {
	tabIndex: 0,
	maxTabIndex: 1,
	mode: HandlingMode.Comfort,
	modalVisible: false,
	modalSaveModel: '',
	modalSaveMode: '',
	unsavedChanges: false,
};

const handlingSlice = createSlice({
	name: 'handling',
	initialState,
	reducers: {
		setTabIndexPrev: (state) => {
			const index = state.tabIndex;
			state.tabIndex = index > 0 ? index - 1 : index;
		},
		setTabIndexNext: (state) => {
			const index = state.tabIndex;
			const maxIndex = state.maxTabIndex;
			state.tabIndex = index < maxIndex ? index + 1 : index;
		},
		setTabIndex: (state, action) => {
			state.tabIndex = action.payload;
		},
		showSaveModal: (state) => {
			state.modalVisible = true;
		},
		hideModal: (state) => {
			state.modalVisible = false;
		},
		setModalSaveParams: (state, action) => {
			state.modalSaveModel = action.payload.model;
			state.modalSaveMode = action.payload.mode;
		},
		setModeValue: (state, action) => {
			state.mode = action.payload;
		},
		setUnsavedChanges: (state, action) => {
			state.unsavedChanges = action.payload;
		},
	},
});

export const {
	setTabIndexPrev,
	setTabIndexNext,
	setTabIndex,
	showSaveModal,
	hideModal,
	setModeValue,
	setUnsavedChanges,
} = handlingSlice.actions;

export default handlingSlice.reducer;
